// Generated from Sector's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type SectorCollectionFilterGroups
  = | {
    readonly spot: Iri | Iri[]
  }
  | {
    readonly id: Iri
  }

export const sectorCollectionFilterMapping: FilterDefinitionMapping<SectorCollectionFilterGroups> = {
  spot: 'spot',
  id: 'id',
}

export type SectorCollectionSort = 'name'
